<template>
  <div>
    <modal-crear-editar :configuracion="configuracion_modal" @realizado="restablecer_inputs"></modal-crear-editar>
    <tablita :cols="columnas" @cargar="cargar($event)" @cargar_url="cargar_url($event)" @nuevo="crear"
      @editar="editar($event)" :configuracion="configuracion_tabla" @especies="modalListado($event)"
      @sucursales="modalSucursales($event)" @datosadicionales="modalDatosAdicionales($event)"
      @proveedores="modalProveedores($event)"
      @refresh="refrescar($event)"></tablita>

    <div class="modal fade" id="modallistado" data-backdrop="static" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div :class="`modal-dialog modal-dialog-centered modal-lg`" role="document" style="width: 80%">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ item_actual.nombre }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-select multiple v-model="item_actual.especies_ids" :options="especies" label="nombre"
              :reduce="(especie) => especie.id" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" data-dismiss="modal" @click="guardarEspecies">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalDatosAdicionales" data-backdrop="static" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div :class="`modal-dialog modal-dialog-centered modal-lg`" role="document" style="width: 80%">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ item_actual.nombre }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-select multiple v-model="item_actual.datos_adicionales_ids" :options="datos_adicionales" label="nombre"
              :reduce="(dato) => dato.id" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" data-dismiss="modal" @click="guardarDatosAdicionales">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalSucursales" data-backdrop="static" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div :class="`modal-dialog modal-dialog-centered modal-lg`" role="document" style="width: 80%">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ item_actual.nombre }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <v-select multiple v-model="item_actual.sucursales_ids" :options="sucursales" label="select"
              :reduce="(dato) => dato.id" /> -->

            <div class="row mb-2">
              <div class="col">
                <div class="custom-control custom-checkbox mb-3">
                  <input class="custom-control-input" id="customCheck2" type="checkbox" v-model="ordenar_sucursales"
                    @change="ordenarSucursales">
                  <label class="custom-control-label" for="customCheck2">Ordenar Seleccionados</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col fixTableHead">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">Asignar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(p, idx) in sucursales" :key="idx">
                      <td>{{ p.select }}</td>
                      <td>
                        <input type="checkbox" name="" id="" :value="p.id" v-model="p.check" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" data-dismiss="modal" @click="guardarSucursales">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalProveedores" data-backdrop="static" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div :class="`modal-dialog modal-dialog-centered modal-lg`" role="document" style="width: 80%">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ item_actual.nombre }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <v-select multiple v-model="item_actual.sucursales_ids" :options="sucursales" label="select"
              :reduce="(dato) => dato.id" /> -->

            <div class="row mb-2">
              <div class="col">
                <div class="custom-control custom-checkbox mb-3">
                  <input class="custom-control-input" id="customCheck2" type="checkbox" v-model="ordenar_empresas"
                    @change="ordenarEmpresas">
                  <label class="custom-control-label" for="customCheck2">Ordenar Seleccionados</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col fixTableHead">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">Asignar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(e, idx) in empresas" :key="idx">
                      <td>{{ e.nombre }}</td>
                      <td>
                        <input type="checkbox" name="" id="" :value="e.id" v-model="e.check" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" data-dismiss="modal" @click="guardarEmpresas">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- <pre>{{item_actual}}</pre>
        <pre>{{especies_ids}}</pre> -->
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "nombre",
        label: "Nombre",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "nombre",
      },
      {
        key: "codigo",
        label: "Código",
        busqueda: "",
        tipo: "numero",
        searchable: true,
        path: "codigo",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
      {
        label: "Especies",
        clase: "btn-primary",
        evento: "especies",
        icono: "fa fa-list",
      },
      {
        label: "Datos Complementarios",
        clase: "btn-primary",
        evento: "datosadicionales",
        icono: "fa fa-list",
      },
      {
        label: "Seleccion de Sucursales",
        clase: "btn-primary",
        evento: "sucursales",
        icono: "fa fa-list",
      },
      {
        label: "Seleccion de Proveedores",
        clase: "btn-primary",
        evento: "proveedores",
        icono: "fa fa-list",
      }
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 6,
        tipo: "texto",
        key: "nombre",
        valor: "",
        label: "Nombre (*)",
        disabled: false,
      },
      {
        cols: 6,
        tipo: "numero",
        key: "codigo",
        valor: "",
        label: "Código",
        disabled: false,
      },
      {
        cols: 6,
        tipo: "numero",
        key: "porcentaje_peso_menor",
        valor: "",
        label: "Porcentaje Peso Menor",
        disabled: false,
      },
      {
        cols: 6,
        tipo: "numero",
        key: "porcentaje_peso_mayor",
        valor: "",
        label: "Porcentaje Peso Mayor",
        disabled: false,
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Tipo Materia Prima",
      ancho: "lg",
      ruta: "/mps_tipo",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Tipos de Materia Prima",
      titulo_boton: "Crear Tipo de Materia Prima",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    /* columns: [
            {label: 'Rut', field: 'rut'},
            {label: 'Nombre', field: 'nombre', headerClass: 'class-in-header second-class'}
        ], */
    item_actual: { especies_ids: [] },
    especies: [],
    especies_ids: [],
    datos_adicionales: [],
    sucursales: [],
    empresas:[],
    ordenar_sucursales: false,
    ordenar_empresas:false
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.$emit("spinner", true);
    this.cargar_especies();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_especies() {
      await this.axios
        .get(`${this.api}/especies?limit=9999999`, this.cabeceras_json)
        .then((res) => {
          this.especies = res.data.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_datos_adicionales();
    },



    async cargar_datos_adicionales() {
      await this.axios
        .get(
          `${this.api}/dato_adicional_guias?limit=9999999`,
          this.cabeceras_json
        )
        .then((res) => {
          this.datos_adicionales = res.data.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_sucursales()
    },

    async cargar_sucursales() {
      await this.axios
        .get(`${this.api}/dependencias?limit=9999999`, this.cabeceras_json)
        .then((res) => {
          this.sucursales = res.data.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_empresas()
    },

    async cargar_empresas() {
      await this.axios
        .get(`${this.api}/empresas?tipo_empresa_ids=4&limit=9999999`, this.cabeceras_json)
        .then((res) => {
          this.empresas = res.data.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.$emit("cargar");
    },

    async cargar($event) {
      this.$emit("spinner", true);
      this.lista = [];
      this.pagina_actual = `${this.api}/mps_tipo${$event}`;
      await this.axios
        .get(`${this.api}/mps_tipo${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("spinner", false);
    },

    ordenarSucursales() {
      if (this.ordenar_sucursales) {
        this.sucursales.sort((a, b) => b.check - a.check)
      } else {
        this.sucursales.sort((a, b) => {
          const nameA = a.nombre.split(' ').join(""); // ignore upper and lowercase
          const nameB = b.nombre.split(' ').join(""); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
        this.sucursales.sort((a, b) => a.nombre - b.nombre)
      }
    },

    ordenarEmpresas() {
      if (this.ordenar_empresas) {
        this.empresas.sort((a, b) => b.check - a.check)
      } else {
        this.empresas.sort((a, b) => {
          const nameA = a.nombre.split(' ').join(""); // ignore upper and lowercase
          const nameB = b.nombre.split(' ').join(""); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
        // this.sucursales.sort((a, b) => a.nombre - b.nombre)
      }
    },
    async cargar_url(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
        this.$emit("spinner", false);
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/mps_tipo`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/mps_tipo/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },

    modalListado(item) {
      //console.log('item',item)
      this.item_actual = item.item;
      $("#modallistado").modal({ show: true });
    },

    modalDatosAdicionales(item) {
      this.item_actual = item.item;
      $("#modalDatosAdicionales").modal({ show: true });
    },

    modalSucursales(item) {
      this.item_actual = item.item;
      this.sucursales.forEach(s => {
        s.check = this.item_actual.sucursales_ids.includes(s.id)
      })
      $("#modalSucursales").modal({ show: true });
    },

    modalProveedores(item) {
      this.item_actual = item.item;
      this.empresas.forEach(s => {
        s.check = this.item_actual.empresas_ids.includes(s.id)
      })
      $("#modalProveedores").modal({ show: true });
    },

    async guardarSucursales() {
      let body = { sucursales_ids: this.sucursales.filter(s => s.check).map(s => s.id) };
      await this.axios
        .post(
          `${this.api}/mps_tipo/${this.item_actual.id}/guardar_sucursales`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          this.cargar(this.query);
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async guardarEmpresas() {
      let body = { empresas_ids: this.empresas.filter(e => e.check).map(e => e.id) };
      await this.axios
        .post(
          `${this.api}/mps_tipo/${this.item_actual.id}/guardar_empresas`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          this.cargar(this.query);
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async guardarEspecies() {
      let body = { especies_ids: this.item_actual.especies_ids };
      await this.axios
        .post(
          `${this.api}/mps_tipo/${this.item_actual.id}/guardar_especies`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          this.cargar(this.query);
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async guardarDatosAdicionales() {
      let body = {
        datos_adicionales_ids: this.item_actual.datos_adicionales_ids,
      };
      await this.axios
        .post(
          `${this.api}/mps_tipo/${this.item_actual.id}/guardar_datos_adicionales`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          this.cargar(this.query);
        })
        .catch((e) => {
          //console.log(e);
        });
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },

    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>